import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { business, navLinks } from "@/data/site";

const serviceLinks = [
  { label: "Residential Roofing", to: "/residential" },
  { label: "Commercial Roofing", to: "/commercial" },
  { label: "Gutters & Siding", to: "/gutters" },
  { label: "Project Gallery", to: "/gallery" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-charcoal text-cream relative grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <p className="font-heading text-3xl">Future Roofing & Repair</p>
            <p className="font-accent text-xs uppercase tracking-[0.2em] text-gold mt-1">
              Family-Owned · Locally Owned
            </p>
            <p className="text-sm text-cream/70 mt-4 leading-relaxed">
              A family-owned, locally operated roofing company in Bristol, PA, serving
              Bucks County and surrounding areas with {business.yearsExperience} years of
              hands-on roofing experience.
            </p>
            <div className="flex flex-wrap gap-2 mt-4 text-[11px] font-accent uppercase tracking-wider">
              <span className="border border-cream/30 px-2 py-1">Licensed</span>
              <span className="border border-cream/30 px-2 py-1">Insured</span>
              <span className="border border-cream/30 px-2 py-1">GAF Certified</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <p className="font-heading text-2xl text-gold mb-4">Services</p>
            <ul className="space-y-2">
              {serviceLinks.map((s) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    className="text-sm text-cream/80 hover:text-gold transition-colors"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Pages */}
          <div>
            <p className="font-heading text-2xl text-gold mb-4">Company</p>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-cream/80 hover:text-gold transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-heading text-2xl text-gold mb-4">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={business.phoneHref} className="flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-call">
                  <Phone className="w-4 h-4 text-gold" /> {business.phone}
                </a>
              </li>
              <li>
                <a href={business.emailHref} className="flex items-center gap-2 hover:text-gold transition-colors break-all">
                  <Mail className="w-4 h-4 text-gold" /> {business.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-cream/80">
                <MapPin className="w-4 h-4 text-gold mt-0.5" /> {business.address.full}
              </li>
              <li className="flex items-center gap-2 text-cream/80">
                <Clock className="w-4 h-4 text-gold" /> {business.hours}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cream/20 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/60">
          <p>© {year} Future Roofing and Repair. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gold transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
        <p className="text-[11px] text-cream/40 mt-4 leading-relaxed">
          Serving Bucks County, Bristol, and surrounding Pennsylvania areas. Workmanship and
          manufacturer warranties may apply depending on the project.
        </p>
      </div>
    </footer>
  );
}
